import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Chip } from "primereact/chip";

export default function PessoaRFDocumento({
    data
}: {
    data: {
        cpf: string;
        nome: string;
        dataNascimento: string;
        situacaoCadastral: string;
        dataSituacaoCadastral: string;
    }
}) {
    const { t } = useTranslation();

    return (
        <Panel header={t('Dados Receita Federal')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                    <div>
                        <label className="label-dados">{t('nome')}</label>
                        <Chip style={{ width: "100%" }} label={data.nome} />
                    </div>
                </div>
                <div className="col p-fluid flex flex-wrap">
                    <div>
                        <label className="label-dados">{t('CPF')}</label>
                        <Chip style={{ width: "100%" }} label={data.cpf} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                    <div>
                        <label className="label-dados">{t('Data de Nascimento')}</label>
                        <Chip style={{ width: "100%" }} label={data.dataNascimento} />
                    </div>
                </div>
                <div className="col p-fluid flex flex-wrap">
                    <div>
                        <label className="label-dados">{t('Situação Cadastral')}</label>
                        <Chip style={{ width: "100%" }} label={data.situacaoCadastral} />
                    </div>
                </div>
            </div>
        </Panel>
    )
}
